export default function (state, val) {
    state.items.splice(state.items.indexOf(val), 1);
}